import { throttle } from '../utils/utilities';

const CLASSES = {
    scrolling_down: 'is-scrolling-down',
    sticky: 'is-sticky',
};

export const Header = (header) => {
    if (!header) return () => {};

    const headerScrollingClass = toggleScrollingClass(header);
    const headerStickyClass = toggleStickyClass(header);

    // Return combined cleanup function
    return () => {
        headerScrollingClass.cleanup();
        headerStickyClass.cleanup();
    };
};

const toggleScrollingClass = (header) => {
    let lastScrollTop = 0;
    let siteHeaderHeight = header.offsetHeight;
    let ticking = false;

    const resizeObserver = new ResizeObserver((entries) => {
        for (const entry of entries) {
            if (entry.borderBoxSize?.[0]) {
                siteHeaderHeight = entry.borderBoxSize[0].blockSize;
            } else {
                siteHeaderHeight = entry.target.offsetHeight;
            }
        }
    });

    resizeObserver.observe(header);

    const handleScroll = () => {
        if (ticking) return;

        ticking = true;
        requestAnimationFrame(() => {
            const scrollTop = window.scrollY || document.documentElement.scrollTop;

            if (scrollTop > lastScrollTop && scrollTop >= siteHeaderHeight) {
                header.classList.add(CLASSES.scrolling_down);
            } else {
                header.classList.remove(CLASSES.scrolling_down);
            }

            lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
            ticking = false;
        });
    };

    window.addEventListener('scroll', handleScroll, { passive: true });

    return {
        cleanup: () => {
            window.removeEventListener('scroll', handleScroll);
            resizeObserver.disconnect();
        },
    };
};

const toggleStickyClass = (header) => {
    const sticky = 0;

    const stickyHeader = () => {
        if (window.scrollY > sticky) {
            header.classList.add(CLASSES.sticky);
        } else {
            header.classList.remove(CLASSES.sticky);
        }
    };

    stickyHeader();

    const scrollCallback = throttle(stickyHeader, 100);
    window.addEventListener('scroll', scrollCallback);

    return {
        cleanup: () => {
            window.removeEventListener('scroll', scrollCallback);
        },
    };
};
